var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32286 13.5833C5.97326 14.7098 6.98153 15.5866 8.18742 16.0743C9.39332 16.5621 10.7276 16.6328 11.9783 16.2752C13.229 15.9176 14.3243 15.1522 15.09 14.1007C15.8558 13.0492 16.2482 11.7719 16.2048 10.4718C16.1613 9.17175 15.6846 7.92349 14.8503 6.92544C14.0161 5.92739 12.8722 5.23683 11.6004 4.96349C10.3287 4.69015 9.00204 4.84974 7.83139 5.41687C6.66073 5.98401 5.71323 6.92616 5.13946 8.09358",
    stroke: "#8f9bba",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24908 7.67849L5.02933 8.54122L4.1666 5.32147",
    stroke: "#8f9bba",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.d9fc9dce7f2ae6608c500d201be0f06f.svg";
export { ForwardRef as ReactComponent };